import { alpha, makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  toggleContainer: {
    display: 'flex',
    gap: 8,
    paddingTop: 8,

    [theme.breakpoints.down('sm')]: {
      justifyContent: 'end',
    }
  },

  toggleButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: "none",
    outline: 'none',
    width: 24,
    height: 24,
    borderRadius: theme.app.borderRadius.sm,
    backgroundColor: '#fff',

    [theme.breakpoints.down('sm')]: {
      width: 32,
      height: 32,
    }
  },
  toggleActive: {
    backgroundColor: alpha(theme.palette.primary.main, 0.1)
  }
}))
